import { mmss } from "../format";

/**
 * Figma countdown ring (B1 "10:00 min offertes", B3 "08:12 restantes"): 104 px, 8.32 px white track,
 * violet progress with square ends, Signika SemiBold 26 violet over an 11 px caption.
 */
export function CountdownRing(props: {
  remainingSec: number;
  totalSec: number;
  caption: string;
  badge?: boolean;
}) {
  const W = 8.32;
  const R = 52 - W / 2;
  const C = 2 * Math.PI * R;
  const frac = () => Math.max(0, Math.min(1, props.remainingSec / props.totalSec));
  return (
    <div class="relative h-[104px] w-[104px]">
      <svg width="104" height="104" viewBox="0 0 104 104" aria-hidden="true">
        <circle cx="52" cy="52" r={R} fill="none" stroke="#fff" stroke-width={W} />
        <circle
          cx="52"
          cy="52"
          r={R}
          fill="none"
          stroke="#6d3e91"
          stroke-width={W}
          stroke-dasharray={`${C}`}
          stroke-dashoffset={`${C * (1 - frac())}`}
          transform="rotate(-90 52 52)"
        />
      </svg>
      <div class="absolute inset-0 flex flex-col items-center justify-center">
        <span class="text-[26px] font-semibold leading-[1.25] tracking-[0.26px] text-violet tabular-nums">
          {mmss(props.remainingSec)}
        </span>
        <span class="text-[11px] leading-[1.25] tracking-[0.11px] text-text">{props.caption}</span>
      </div>
      {props.badge && (
        <span class="absolute right-0 bottom-1 h-6 w-6 rounded-full bg-[#e53935] border-2 border-white flex items-center justify-center">
          <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
            <path d="M2 2l6 6M8 2L2 8" stroke="#fff" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </span>
      )}
    </div>
  );
}
